import {
  colourSwatchSelectorControlSize,
  colourSwatchSelectorWidth,
} from '@/features/shared/components/colourSwatchSelectorMetrics';
import { r, s } from '@/theme/tokens';
import {
  tooltipOverlayFontSize,
  tooltipOverlayLineHeight,
} from '@/ui/primitives/tooltipOverlayStyles';
import { resolveTableActionIconAccentColor } from './tableMetricAccentStyles';
import { tableControlHoverBackground, tableControlSurfaceBackground } from './tablePanelSurfaceSx';
import type { SxProps, Theme } from '@/ui/primitives';

type ThemeSxObject = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;
type ThemeSxFn = (theme: Theme) => ThemeSxObject;

export const tableRowTagsTooltipTextSx = {
  fontSize: tooltipOverlayFontSize,
  lineHeight: tooltipOverlayLineHeight,
} as const;

export const tableRowTagsTooltipSlotSx = {
  fontSize: tooltipOverlayFontSize,
  lineHeight: tooltipOverlayLineHeight,
  maxWidth: 440,
} as const;

export const tableRowTagsInfoButtonSx = {
  p: s('none'),
  color: 'text.secondary',
} as const;

export const tableRowTagsAddButtonSx = {
  pl: s('none'),
  minWidth: 0,
  '& .MuiButton-startIcon': {
    marginLeft: s('none'),
    marginRight: s('xxxs'),
  },
} as const;

export const tableRowTagsAddButtonIconSx: ThemeSxFn = (theme) => ({
  fontSize: theme.app.iconSizes.sm,
});

export const tableRowTagEditorRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: s('sm'),
  width: '100%',
} as const;

export const tableRowTagEditorControlsSx = {
  flex: 1,
  minWidth: 0,
  display: 'grid',
  gridTemplateColumns: `minmax(0, 1fr) ${colourSwatchSelectorWidth}`,
  alignItems: 'center',
  gap: s('md'),
} as const;

export const tableRowTagEditorTextFieldSx: ThemeSxFn = (theme) => ({
  '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
    backgroundColor: tableControlSurfaceBackground,
    minHeight: colourSwatchSelectorControlSize,
    height: colourSwatchSelectorControlSize,
  },
  '& .MuiInputBase-input, & .MuiOutlinedInput-input': {
    fontSize: theme.typography.subtitle1.fontSize,
    lineHeight: theme.typography.subtitle1.lineHeight,
  },
});

export const tableRowTagEditorRemoveButtonSx = {
  width: `calc(${s('2xl')} + ${s('sm')})`,
  height: `calc(${s('2xl')} + ${s('sm')})`,
  minWidth: `calc(${s('2xl')} + ${s('sm')})`,
  minHeight: `calc(${s('2xl')} + ${s('sm')})`,
  p: s('none'),
  borderRadius: r('chip'),
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: tableControlHoverBackground,
  },
} as const;

export const tableRowTagEditorRemoveIconSx = {
  color: (theme: Theme) => resolveTableActionIconAccentColor(theme, 'error'),
  fontSize: `calc(${s('2xl')} + ${s('xs')})`,
} as const;
